module.exports = __webpack_public_path__ + "img/wibo-04.be79db80.jpg";